<template>
  <div class="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl shadow-md p-4 border border-blue-100">
    <div class="flex items-center justify-between flex-wrap gap-4">
      <div class="flex items-center gap-3">
        <span class="text-3xl">📅</span>
        <div>
          <h3 class="text-lg font-semibold text-gray-800">Período de Análisis</h3>
          <p class="text-sm text-gray-600">{{ metadata.periodo_tipo }}</p>
        </div>
      </div>
      
      <div class="flex flex-wrap gap-6 text-sm">
        <div>
          <span class="text-gray-600">Desde:</span>
          <span class="ml-2 font-semibold text-gray-800">{{ formatearFecha(metadata.fecha_inicio) }}</span>
        </div>
        <div>
          <span class="text-gray-600">Hasta:</span>
          <span class="ml-2 font-semibold text-gray-800">{{ formatearFecha(metadata.fecha_fin) }}</span>
        </div>
        <div>
          <span class="text-gray-600">Días:</span>
          <span class="ml-2 font-semibold text-blue-600">{{ metadata.dias_en_periodo }}</span>
        </div>
        <div v-if="metadata.es_periodo_actual" class="flex items-center gap-1 text-green-600">
          <span>🟢</span>
          <span class="font-medium">Período Actual</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MetadataCard',
  props: {
    metadata: {
      type: Object,
      required: true
    }
  },
  methods: {
    formatearFecha(fecha) {
      const date = new Date(fecha + 'T00:00:00');
      return date.toLocaleDateString('es-MX', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    }
  }
};
</script>
